import React from 'react';
import { NavLink } from 'react-router-dom';

import project_logo from '../../assets/images/fmrs_logo.png';
import classes from './Logo.module.css';

const logo = (props) => {
    return (
        <div className={classes.Logo}>
            <NavLink 
                to="/"
                exact={true}
            >
                <img src={project_logo} alt="FRMS logo" />
            </NavLink>
            
        </div>
    )
};

export default logo;